import React from "react";
import { FormattedMessage } from "react-intl";
// entity/slice
export const organizationTypes = [
    { value: "agency", text: "Agency" },
    { value: "corporate", text: "Corporate" },
];


export const commonFields = [{
    name: "name",
    label: <FormattedMessage id="organization-form.name" />,
    type: "string",
    helpText: <FormattedMessage id="organization-form.help-txt-name" />,
    errorMessage: <FormattedMessage id="organization-form.err-msg-name" />,
    url: "/organizations",
    filterValue: "name",
    validation: {
        required: true,
    },
},
{
    name: "commercialRegisterName",
    label: <FormattedMessage id="client.commercialRegisterName" />,
    type: "string",
},
{
    name: "website",
    label: <FormattedMessage id="client.website" />,
    type: "string",
},
{
    name: "industry",
    label: <FormattedMessage id="client.industry" />,
    type: "string",
},
{
    name: "headquarter",
    label: <FormattedMessage id="client.headquarter" />,
    type: "string",
},
{
    name: "distributionChannelIds",
    label: <FormattedMessage id="client.distributionChannels" />,
    type: "list",
    url: "/distribution-channels",
    filterValue: "slug",
    isMultiple: true,
    entityName: "distributionChannels",
    include: true,
},
{
    name: "startDate",
    label: <FormattedMessage id="client.startDate" />,
    type: "date",
},
{
    name: "inactiveDate",
    label: <FormattedMessage id="client.inactiveDate" />,
    type: "date",
},]



export default [...commonFields,
{
    name: "organizationType",
    label: <FormattedMessage id="organization-form.type" />,
    type: "select",
    helpText: <FormattedMessage id="organization-form.help-txt-type" />,
    errorMessage: <FormattedMessage id="organization-form.err-msg-type" />,
    data: organizationTypes,
    validation: {
        required: true,
    },
},
{
    name: "recipients",
    label: <FormattedMessage id="organization-form.mail-recipients" />,
    type: "string",
    helpText: "a comma separated list of emails that we should send notifications to",
    validation: {
        required: false,
    },
},
{
    name: "shouldNotify",
    label: <FormattedMessage id="client.notify" />,
    type: "checkbox",
    helpText:
        "it allows clients to track their trips by sending trip tracking links to their email inboxes",
    validation: {
        required: false,
    },
},
];
